import script from "./appGroupDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./appGroupDelete.vue?vue&type=script&setup=true&lang=js"

import "./appGroupDelete.vue?vue&type=style&index=0&id=492d5e6b&lang=css"

const __exports__ = script;

export default __exports__